export const comments_5618857 = {"data":{"data":[],"links":{}}}